import { env, mergeObjectIf, Storage, Store, truncate } from "../helpers"

export const Role = {
  SUPER_ADMIN: "SUPER_ADMIN",
  ADMIN: "ADMIN",
  OP_MANAGER: "OP_MANAGER",
  HELP_DESK: "HELP_DESK",
  CONTROLLER: "CONTROLLER",
  TRESORPAY_MANAGER: "TRESORPAY_MANAGER",
}

export const Auth = {
  user() {
    return Storage.get("user")
  },
  id() {
    if (this.isAuthenticated()) {
      return this.user().id
    }
  },
  name() {
    if (this.isAuthenticated()) {
      const user = this.user()
      return truncate(`${user.first_name} ${user.last_name}`, 15)
    }
  },
  hasRole(role) {
    if (this.isAuthenticated()) {
      if (!role) {
        return true
      }

      const roles = this.user().roles

      if (role.constructor === Array) {
        if (role.length === 1) {
          role = role[0]
        } else {
          return !!roles.find(r => role.includes(r.slug))
        }
      }

      return !!roles.find(r => r.slug === role)
    }
    return false
  },
  role() {
    if (this.isAuthenticated()) {
      const roles = this.user()
        .roles
        .filter(r => Object.values(Role)
          .includes(r.slug))
        .sort((r1, r2) => r1.value - r2.value)

      if (roles.length) {
        return roles[0]
      }
    }
    return null
  },
  roleName() {
    const role = this.role()
    if (role) {
      return role.name
    }
  },
  token() {
    if (this.isAuthenticated()) {
      return this.user()["authorization_token"]
    }
  },
  authenticateUser(data, remember = false) {
    data.remember = remember
    Storage.store("user", data)
    Store.commit("refreshAuth")
  },
  logout() {
    Storage.remove("user")
  },
  isAuthenticated() {
    const user = this.user()
    return user && user["authorization_token"]
  },
  isAdmin() {
    return this.hasRole([Role.ADMIN, Role.SUPER_ADMIN])
  },
  isOpManager() {
    return this.isAdmin() || this.hasRole(Role.OP_MANAGER)
  },
  isHelpDesk() {
    return this.isAdmin() || this.hasRole(Role.HELP_DESK)
  },
  isController() {
    return this.isAdmin() || this.hasRole(Role.CONTROLLER)
  },
  isTresorPayManager() {
    return this.isAdmin() || this.hasRole(Role.TRESORPAY_MANAGER)
  },
  homePage() {
    if (this.isController()) {
      return { name: "dashboard" }
    }

    if (this.isTresorPayManager()) {
      return { name: "tresorpay" }
    }

    return { name: "transactions" }
  },
}

// Adds authorization token (Json Web Token) to request options
export const jwt = (options) => {
  if (!options) {
    options = {}
  }

  if (!options.headers) {
    options.headers = {}
  }

  if (env("NODE_ENV") !== "production") {
    options.headers["Cache-Control"] = "no-cache"
  }

  if (Auth.isAuthenticated()) {
    options.headers["Authorization"] = "Bearer " + Auth.token()
  }

  return options
}

export default {
  computed: {
    auth() {
      return Auth
    },
  },
  methods: {
    logout(redirect = false) {
      this.auth.logout()
      this.$router.push({
        name: "login",
        ...mergeObjectIf(redirect, {
          query: { redirect: this.$route.fullPath },
        }),
      })
    },
  },
}
